"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_multiplier_1 = require("./base-multiplier");
const format_1 = require("./format");
exports.MULTIPLIERS = {
    [format_1.Format.kB]: base_multiplier_1.BASE_MULTIPLIER,
    [format_1.Format.MB]: base_multiplier_1.BASE_MULTIPLIER ** 2,
    [format_1.Format.GB]: base_multiplier_1.BASE_MULTIPLIER ** 3,
    [format_1.Format.TB]: base_multiplier_1.BASE_MULTIPLIER ** 4,
};
//# sourceMappingURL=multipliers.js.map